import React, { Component, FormEvent, ChangeEvent } from 'react';
import {
    FormGroup,
    Button,
    Input,
    Form,
} from 'reactstrap';
import { withFirebase } from '../Firebase';

type AccountPasswordChangeState = {
    passwordOne: string;
    passwordTwo: string;
    error: null | any;
};

type AccountPasswordChangeProps = {
    firebase: any;
};

const INITIAL_STATE: AccountPasswordChangeState = {
    passwordOne: '',
    passwordTwo: '',
    error: null,
};

class AccountPasswordChangeForm extends Component<
    AccountPasswordChangeProps,
    AccountPasswordChangeState & { showSuccess?: boolean }
> {
    constructor(props: AccountPasswordChangeProps) {
        super(props);
        this.state = { ...INITIAL_STATE, showSuccess: false };
    }

    onSubmit = (event: FormEvent<HTMLFormElement>) => {
        const { passwordOne } = this.state;
        this.props.firebase
            .doPasswordUpdate(passwordOne)
            .then(() => {
                this.setState({ ...INITIAL_STATE, showSuccess: true });
                setTimeout(() => {
                    this.setState({ showSuccess: false });
                }, 3000);
            })
            .catch((error: Error) => {
                this.setState({ error });
            });
        event.preventDefault();
    };

    onChange = (event: ChangeEvent<HTMLInputElement>) => {
        this.setState({ [event.target.name]: event.target.value } as any);
    };

    render() {
        const { passwordOne, passwordTwo, error, showSuccess }: AccountPasswordChangeState & { showSuccess?: boolean } = this.state;
        const isInvalid = passwordOne !== passwordTwo || passwordOne === '';

        return (
            <div className="mb-4">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h6 className="mb-0 font-weight-bold">Change Password</h6>
                    <Button
                        className="btn-primary-custom btn-sm"
                        disabled={isInvalid}
                        type="submit"
                        form="password-change-form"
                    >
                        Change
                    </Button>
                </div>
                {showSuccess && (
                    <div className="alert alert-success text-center mb-3" role="alert">
                        Password changed successfully!
                    </div>
                )}
                <Form onSubmit={this.onSubmit} id="password-change-form">
                    <FormGroup className="mb-3">
                        <Input
                            name="passwordOne"
                            value={passwordOne}
                            onChange={this.onChange}
                            type="password"
                            placeholder="New Password"
                            className="form-control"
                        />
                    </FormGroup>
                    <FormGroup className="mb-3">
                        <Input
                            name="passwordTwo"
                            value={passwordTwo}
                            onChange={this.onChange}
                            type="password"
                            placeholder="Confirm New Password"
                            className="form-control"
                        />
                    </FormGroup>
                    {error && <p className="text-danger small">{error.message}</p>}
                </Form>
            </div>
        );
    }
}

export default withFirebase(AccountPasswordChangeForm);